import { axiosWithHeaders } from '@innovyze/lib_get_service';
import axiosRetry from 'axios-retry';
import _ from 'lodash';
import { useEffect, useMemo, useState } from 'react';
import { apiConfig } from '../../../apis/config.api';

const useCustomKpi = (
  baseURL: string,
  url: string,
  path: string[],
  params?: {
    [param: string]: unknown;
  }
): {
  value: number | string;
  loading: boolean;
} => {
  const [data, setData] = useState();
  const [loading, setLoading] = useState<boolean>(false);
  useEffect(() => {
    setLoading(true);
    const fetchData = async () => {
      // const kpiApi = axios.create(options);
      const kpiApi = axiosWithHeaders({
        service: 'goals',
        config: apiConfig,
        axiosCreateOpts: {
          baseURL, // override with provided baseURL
          timeout: 5000,
        },
      });

      axiosRetry(kpiApi, {
        retries: 3,
        retryDelay: (retryCount) => {
          return retryCount * 500;
        },
      });

      const response = await kpiApi.get(url, {
        params: params,
      });
      if (response.status === 200) {
        setData(response.data);
      }
    };
    setLoading(false);
    fetchData();
  }, []);

  return useMemo(
    () => ({ value: _.get(data, path, '0'), loading }),
    [baseURL, url, path, params]
  );
};

export default useCustomKpi;
